/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CrashObject} from "../../model/CrashObject";
import {NgxSpinnerService} from 'ngx-spinner';
import {CrashObjectDefinitionService} from "../../services/crash-object-definition.service";
import {NgForm} from "@angular/forms";
import {BaseNgFormAdminComponent} from '../../common/base-ngform-admin.component';

@Component({
    selector: 'app-accident-crash-object',
    templateUrl: './accident-crash-object.component.html',
    styleUrls: ['./accident-crash-object.component.less'],
    standalone: false
})
export class AccidentCrashObjectComponent extends BaseNgFormAdminComponent implements OnInit {
  public crashObjects: CrashObject[];

  constructor(private spinnerService: NgxSpinnerService,
              private crashObjectService: CrashObjectDefinitionService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getAllCrashObjects();
  }

  protected reloadData(): void {
    this.getAllCrashObjects();
  }

  private getAllCrashObjects(){
    this.spinnerService.show();
    this.crashObjectService.getAll().subscribe(value => {
        this.crashObjects = value;
        this.cdr.detectChanges();
      },
      err => {
        this.spinnerService.hide();
        console.log(err);
        alert(err);
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  addNew(newType: string, newDesc: string){
    this.spinnerService.show();
    var newCrashObject = new CrashObject();
    newCrashObject.crashObjectType = newType;
    newCrashObject.crashObjectDesc = newDesc;

    this.crashObjectService.addCrashObject(newCrashObject).subscribe(retVal=>{
      this.getAllCrashObjects();
    },(error)=>{
      this.spinnerService.hide();
      if (error.status=='409')
        alert("Duplicate Value(s) found.");
      else
        alert(error.message);
    },()=>{
      this.spinnerService.hide();
      this.returnMessage = 'Adding accident crash object finished';
      setTimeout(() => {
        this.returnMessage = '';
      },2000);
    });
  }

  onSubmit(f: NgForm) {
    this.spinnerService.show();
    let count = 0;
    let array = this.getChangedIndex(f);
    var crashObjectIds = array.filter(function(elem, index, self) {
      return index == self.indexOf(elem);
    });
    if (crashObjectIds!=null && crashObjectIds.length>0)
    {
      crashObjectIds.forEach(vdi=>{
        var CrashObjectChanged = this.crashObjects.find(x=>x.crashObjectDefinitionId === vdi);
        this.crashObjectService.updateCrashObjectById(CrashObjectChanged).subscribe(retValue=>{
          //something here?
        },(error)=>{
          this.spinnerService.hide();
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.returnMessage = '';
          this.getAllCrashObjects();
          count = 0;
        },()=>{
          count = count + 1;
          if (count>=crashObjectIds.length) {
            this.clearNgForm();
            count =0;
            this.spinnerService.hide();
          }
        });
      });
    }
    else{
      this.spinnerService.hide();
      alert("No changes to save.");
    }
  }

  private clearNgForm(){
    this.returnMessage = '';
    this.getAllCrashObjects();
    this.returnMessage = 'Updating accident crash object finished';
    setTimeout(() => {
      this.returnMessage = '';
    }, 2000);
  }

}
